// MWA-394 — what a client is told when they have no prep guide to read.
//
// get-interview and list-interviews strip a draft guide for a client, and
// they also strip the draft flag itself, so a client can never see
// `prepGuideIsDraft`. The one thing they leave behind is
// `prepGuideStatus: 'not_available'`, set only when a draft was hidden. An
// interview with no guide at all carries no such status. That is the only
// way to tell "being reviewed" from "not generated yet" on the client side.

export const GUIDE_BEING_REVIEWED_COPY =
  'Your prep guide is being reviewed by your strategist. You will have access shortly.'

export const GUIDE_BEING_PREPARED_COPY =
  'Your prep guide is being prepared. You will see it here when it is ready.'

export function isGuideHiddenFromClient(interview: {
  prepGuide?: unknown
  prepGuideStatus?: string
}): boolean {
  return !interview.prepGuide && interview.prepGuideStatus === 'not_available'
}
